import { render, staticRenderFns } from "./LayoutColumnComponent.vue?vue&type=template&id=6cdca2d4&scoped=true&"
import script from "./LayoutColumnComponent.vue?vue&type=script&lang=js&"
export * from "./LayoutColumnComponent.vue?vue&type=script&lang=js&"
import style0 from "./LayoutColumnComponent.vue?vue&type=style&index=0&id=6cdca2d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdca2d4",
  null
  
)

export default component.exports